export const FEEDBACK_COOKIE_NAME = 'feedback_banner_hide';
